import types from '../types'

export const setHeaderKey = (key) => {
  return (dispatch) => dispatch({ type: types.SET_ACTIVE_HEADER_KEY, payload: key })
}

export const setNextClicked = (clicked) => (dispatch) => dispatch({ type: types.SET_NEXT_CLICKED, payload: clicked })

export const setShowExitModal = (show) => (dispatch) => dispatch({ type: types.SET_SHOW_EXIT_MODAL, payload: show })

export const setExitModal = (payload) => (dispatch) => dispatch({ type: types.SET_EXIT_MODAL, payload })
